import React, { useEffect, useState } from 'react'
import { API_KEY, imageUrl } from '../../constants/constants'
import axios from '../../axios'
import './Banner.css'

function Banner() {
  const [movie, setMovie] = useState()

  useEffect(() => {
    axios.get(`trending/all/week?api_key=${API_KEY}&language=en-US`).then((response) => {
      console.log(response.data.results[0])
      setMovie(response.data.results[Math.floor(Math.random() * response.data.results.length - 1)])
    }).catch(err => {
      if (err.isMockData) {
        const results = err.mockResponse.data.results;
        setMovie(results[Math.floor(Math.random() * results.length - 1)])
      }
    })

  }, [])

  function truncate(str, n) {
    return str?.length > n ? str.substr(0, n - 1) + "..." : str;
  }

  return (
    <div
      style={{ backgroundImage: `url(${movie ? (movie.backdrop_path.startsWith('http') ? movie.backdrop_path : imageUrl + movie.backdrop_path) : ""})` }}
      className='banner'>
      <div className='content'>
        <h1 className='title'>{movie ? movie.title || movie.name || movie.original_name : "Movie Title"}</h1>
        <div className='buttons'>
          <button className='button'>Play</button>
          <button className='button'>My List</button>
        </div>
        <h1 className='description'>{truncate(movie?.overview, 150)}</h1>
      </div>
      <div className="fade_bottom"></div>
    </div>
  )
}

export default Banner
